export enum PaginationEnum {
  PageSize = 15
}
export enum ConfigurationEnum {
  USER_TYPE = 1,
  ATTACHMENT_TYPE = 2,
  VEHICLE_TYPE = 3,
  SHIPMENT_TYPE = 4,
  BANK_TYPE = 5,
  USER_STATUS = 31,
  OLD_USER_STATUS = 6,
  SHIPMENT_STATUS = 7,
  USER_CLASS = 8,
  BUSINESS_TYPE = 9,
  VEHICLE_STATUS = 10,
  BANK_STATUS = 11,
  PAYMENT_METHOD = 12,
  CHAT_TYPE = 13,
  DELIVERY_TYPE = 14,
  IDENTITY_STATUS = 15,
  RIDE_STATUS = 16,
  RIDEPAYMENT_METHOD = 17,
  FUEL_TYPE = 18
}

export enum RoleEnum {
  None = 0,
  Admin = 1,
  Sub_Admin = 2,
  Sender_Receiver = 3,
  Delivery_Associate = 4,
  Specialist = 5,
  Nurse = 6,
  Ambulance = 7

}

export enum GenderEnum {
  GenderValue = 18
}


export enum AttachmentTypeCD {
  Personal = 21,
  Vehicle = 22,
  Shipment = 23,
  ProfilePic = 24,
  CompletedShipmentItem = 25,
  VehicleMobility = 26, AddressProof = 27
}


export enum SortOrder {
  LowToHighEarning = 1,
  HighToLowEarning = 2,
  LowToHighRating = 3,
  HighToLowRating = 4,
  NewToOld = 5,
  OldToNew = 6
}

export enum ShipmentStatusCD {
  all = 0,
  upcoming = 122,
  ongoing = 130,
  declined = 123,
  cancelled = 136,
  delivered = 133,
  unassigned = 121
}


export enum UserReportCD {
  all = 0,
  pending = 1,
  underreview = 2,
  cancelled = 4,
  resolved = 3
}


export enum RideStatusCD {
  all = 0,
  Created = 301,
  Declined = 302,
  Cancelled = 303,
  Accepted = 304,
  ReachedPickupPoint = 305,
  InTransit = 306,
  Reached_DropPoint = 307,
  Completed = 308,
  Disputed = 309,
  Resolved = 310,
  Scheduled = 311
}


export enum ShipmentStatusEnum {
  Created = 121,
  Accepted = 122,
  Declined = 123,
  ReadyToPickup = 124,
  ReachedPickupPoint = 125,
  PendingVerification = 126,
  SenderVerified = 127,
  DriverVerified = 128,
  ShipmentVerified = 129,
  PickedUp_InTransit = 130,
  DeliveryInitiated = 131,
  DeliveryVerified = 132,
  Delivered = 133,
  Disputed = 134,
  Resolved = 135,
  Cancelled = 136,
  PickupScheduled = 137,
  PickupCancelled = 138,
  CreationFailed = 139,
  Dispatched = 140
}

export enum UserStatusCD {
  Registered = 101,
  ReviewInProcess = 102,
  Approved = 103,
  Rejected = 104,
  Blocked = 105,
  Unsubscribe = 106,
  Deleted = 107,
  PermamnentDeleted = 108,
  RegistrationInProcess = 109,
  Expired = 110
}

export enum UserStatusCDName {
  All = "All",
  Created = "Created",
  ReviewInProcess = "ReviewInProcess",
  Approved = "Approved",
  Rejected = "Rejected",
  Registered = "Registered",
  Deleted = "Deleted",
  Blocked = "Blocked",
  Unsubscribe = "Unsubscribe",
  PermanentDeleted = 'PermanentDeleted',
  RegistrationInProcess = "RegistrationInProcess",
  Expired = "Expired"
}

export enum UserPhaseStatusCD {
  Registered = 462,
  Phase1Submitted = 463,
  Phase1Approved = 464,
  Phase1Rejected = 465,
  Deleted = 466,
  Unsubscribe = 481,
  DeletedPermanently = 467,
  Phase2Submitted = 468,
  Phase2Approved = 470,
  Phase2Rejected = 469,
  Approved = 476,
  Phase1InProcess = 477,
  Phase2InProcess = 478,
  Phase3InProcess = 479,
  Blocked = 480,
}

export enum UserPhaseStatusCDName {
  All = "All",
  Registered = "Registered",
  Phase1Submitted = 'Phase 1 Submitted',
  Phase1Approved = "Phase 1 Approved",
  Phase1Rejected = 'Phase 1 Rejected',
  Deleted = "Deleted",
  Unsubscribe = "Unsubscribe",
  PermanentDeleted = 'Permanent Deleted',
  Phase2Submitted = 'Phase 2 Submitted',
  Phase2Approved = "Phase 2 Approved",
  Phase2Rejected = 'Phase 2 Rejected',
  Phase3Submitted = 'Phase 3 Submitted',
  Approved = "Approved",
  Phase1InProcess = 'Phase 1 In Process',
  Phase2InProcess = 'Phase 2 In Process',
  Phase3InProcess = 'Phase 3 In Process',
  Blocked = "Blocked",
}

export enum VehicleStatusCD {
  ReviewInProcess = 181,
  Approved = 182,
  Rejected = 183,
  Blocked = 184,
  Enable = 185,
  Disable = 186,
  Deleted = 187,
  Expired = 188
}

export enum Status {
  Approve = 1,
  Reject = 2,
  Block = 3,
  Unblock = 4,
  Hold = 5,
  Unsubscribe = 6,
  Remove = 7
}

export enum BankStatusCD {
  Registered = 201,
  Approved = 202,
  Rejected = 203,
  OnHold = 204,
  Enable = 205,
  Disable = 206,
  ReviewInProcess = 207
}

export enum IdentityStatusCD {
  ReviewInProcess = 281,
  Approved = 282,
  Rejected = 283
}

export enum RegistrationPhase {
  phase1 = 1,
  Phase2 = 2,
  Phase3 = 3,
  Phase4 = 4
}


export enum PaymentModeEnum {
  Cash = 'CASH',
  CashOnPickup = 'CASH_ON_PICKUP',
  CashOnDelivery = 'CASH_ON_DELIVERY',
  Wallet = 'WALLET',
  Paypal = 'PAYPAL',
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD'
}

export enum RidePaymentModeCD {
  Cash = 1,
  Wallet = 4,
  Paypal = 5,
  CreditCard = 6
}

export enum KEY_CODE {
  Ctrl_A = 65,
  Ctrl_C = 67,
  Ctrl_V = 86,
  Ctrl_X = 88,
  Home = 35,
  Right = 39,
  Left = 37,
  Back_space = 8,
  End = 36,
  Space_Tab = 32,
  NumStart_Key_Code = 96,
  NumEnd_Key_Code = 105,
  NumUpper_Key_Code = 48,
  NumLower_Key_Code = 57,
  Dot_Key_Code = 190

}

export enum UserPermissionsEnum {
  Welcome = 'Welcome',
  Order = 'Services',
  Partner = 'Driver/Delivery Partner',
  User_Employee = 'User&Employee',
  PartnerNurse = "Partner Nurse",
  PartnerAmbulance = "Partner Ambulance",
  Doctor = "Doctor",
  Country = 'Country',
  State = 'State',
  City = 'City',
  ShipmentSizeConfig = 'Shipment-Size-Config',
  ShipmentCarrier = 'Shipment-Carrier',
  ShippingChargeConfig = 'Shipping-Charge-Config',
  BankConfiguration = 'Bank-Configuration',
  ConfigSettings = 'Config-Settings',
  CancellationCharge = 'Cancellation-Charge',
  VehicleCategory = 'Vehicle-Category',
  AppVersions = 'App-Versions',
  BannerManagement = 'BannerManagement',
  Coupon = 'Coupon',
  NotificationTemplate = 'Notification Template',
  Employees = 'Employees',
  VOOYUsers = 'VOOY Users',
  VOOYPartners = 'VOOY Driver/Delivery Partner',
  VOOYDoctors = 'VOOY Doctors',
  VOOYNurses = "VOOY Nurses",
  RestaurentPartners = "VOOY Restaurants",
  VOOYAmbulances = "VOOY Ambulances",
  WithdrawRequests = 'Withdraw-Requests',
  ShipmentList = 'Shipment-List',
  RideList = 'Ride-List',
  OrderGroup = "Order Group List",
  MedicalAppointmentList = "Medical Appointment List",
  NursingAppointmentList = "Nursing Appointment List",
  ShuttleServices = "Shuttle Services",
  FoodOrderList = "Food Order List",
  FoodCategory = "Food-Category",
  SystemVariableSettings = "System Variable Settings",
  UILabelSettings = "UI Label Settings",
  FoodOffer = "Food-Offer",
  Tickets = "Tickets",
  Notification = "Notification",
  RideShipmentNotification = "Ride&ShipmentNotification",
  FoodNotification = "FoodNotification",
  HealthNotification = "HealthNotification",
  Productivity = "Productivity",
  SMSNotification = "SMSNotification",
  PushNotification = "PushNotification",
  EmailNotification = "EmailNotification",
  OnlinePartners = "OnlinePartners",
  ReferralConfiguration = "ReferralConfiguration",
  DriverWallets = "DriverWallets",
  Centrodereportes="Centro de reportes",
  Userreportspartner = "User reports partner",
  Partnerreportsuser = "Partner reports user"
}

export enum PermissionsEnum {
  ViewAll = 'ViewAll',
  View = 'View',
  Add = 'Add',
  Update = 'Update',
  Delete = 'Delete'
}

export enum VehicleTypeEnum {
  BICYCLE = "BICYCLE",
  MOTORCYCLE = "MOTORCYCLE",
  CAR = "CAR",
  PICKUPANDVAN = "PICKUPANDVAN",
}


export enum LanguageCode {
  English = 1,
  Spanish = 2,
}

export enum CountryCode {
  SelectedCountryCode = "+52",
}

export enum ServiceType {
  shipment = 1,
  ride = 2,
  help = 3,
  food = 4,
  health = 5,
  destination = 8
}
export enum LanguageCodeEnum {
  US_English = "en-US",
  MX_Spanish = "es-MX",
  ENGLISH = 'ENGLISH',
  SPANISH = 'SPANISH'
}

export enum HealthStaffEnum {
  AmublanceDriver = "AMB_DRIVER",
  Doctor = "DOCTOR",
  Nurse = "NURSE"
}

export enum HealthStatusEnum {
  Created = "C",
  Approved = "A",
  Pending = "P",
  Rejected = "R",
  Deleted = "D",
  PermanentDeleted = "PD",
  Restore = "",
  All = '',
  Blocked = "B"
}

export enum TicketEnum {
  Priority_Type = 'PRIORITY_TYPE',
  Ticket_Status = 'TICKET_STATUS'

}

export enum TicketStatusEnum {
  Open = 'Open',
  Pending = 'Pending',
  Cancelled = 'Cancelled',
  Closed = "Closed",
  Resolved = "Resolved",
  Assigned = "Assigned"
}

export enum ApplicationEnum {
  logistic = "LOGISTIC01",
  logistic2 = "LOGISTIC02",
  Health = "HEALTH0001",
  Food = "FOOD00002"
}

export enum UserTypeCD {
  CUSTOMER = "CUSTOMER",
  DELIVERY_PARTNER = "DELIVERY_PARTNER",
  SELLER = "SELLER",
  DOCTOR = "DOCTOR",
  NURSE = "NURSE",
  AMBULANCEDRIVER = "AMBULANCEDRIVER",
  CUSTOMER_SENDER = "CUSTOMER_SENDER",
  CUSTOMER_RECEIVER = "CUSTOMER_RECEIVER"
}

// {
//     "cd": "CUSTOMER",
//     "description": "Customer"
//   },
//   {
//     "cd": "DELIVERY_PARTNER",
//     "description": "Delivery Aprtner"
//   },
//   {
//     "cd": "SELLER",
//     "description": "Seller"
//   },
//   {
//     "cd": "DOCTOR",
//     "description": "Doctor"
//   },
//   {
//     "cd": "NURSE",
//     "description": "Nurse"
//   },
//   {
//     "cd": "AMBULANCEDRIVER",
//     "description": "Ambulance Driver"
//   },
//   {
//     "cd": "CUSTOMER_SENDER",
//     "description": "Customer Sender"
//   },
//   {
//     "cd": "CUSTOMER_RECEIVER",
//     "description": "Customer Receiver"
//   }
export enum PaymentEnum {
  CASH = "COD",
  NOT_APPLICABLE = "NOT_APPLICABLE",
  PREPAID = "PREPAID",
  PAYPAL = "PAYPAL",
  WALLET = "WALLET",
  CREDIT_CARD = "CREDIT_CARD",
  DEBIT_CARD = "DEBIT_CARD",
}

export enum UserRole {
  Admin = "admin",
  SubAdmin = "subAdmin",
  Seller = "seller",
  Customer = "customer",
  Doctor = "doctor",
  Nurse = "nurse",
  AmbDriver = "ambulanceDriver",
  Driver = "driver",
  Service = "service",
  HealthEditor = "healtheditor",
  HelpPartner = "VOOY_RIDE_DELIVERY_PARTNER_ORDER",
  HelpCustomer = "VOOY_RIDE_DELIVERY_CUSTOMER_ORDER"
}

export enum LinkEnum {
  FORGOT_PASSWORD = "FORGOT_PASSWORD",
  ADMIN = "ADM"
}

export enum SellerComission {
  AMOUNT = 'AMOUNT_VALUE',
  PERCENTAGE = 'PERCENTAGE_VALUE'
}

export enum OrderStatusCD {
  All = 0,
  Awaited = 1,
  Ongoing = 2,
  Delivered = 3,
  Cancelled = 4
}

export enum SellerStatus {
  OptionGroup = 1,
  Product = 2,
  Order = 3,
  Earning = 4
}

export enum SellerStatusEnum {
  Approved = "A",
  Registered = "C",
  Rejected = "R",
  ReviewInProcess = "P",
  Deleted = "D",
  Blocked = "B"
}

export enum HealthFileEnum {
  DoctorAddress = "DOC26F068B",
  NurseAddress = "D2826F068B",
  INEFrontPhotography = "INE Front Photography",
  DoctorProfileConfiguration = "Doctor Profile Configuration",
  HealthContract = "DOCDF67890",
  NurseHealthContractCategory = "NURSEF67890",
  AmbulanceHealthContractCategory = "AMBDF67890"
}

export enum HealthEditorMails {
  testServer = 'health@vooyapp.com',
  devServer = 'health@gmail.com',
  preServer = 'health@vooyapp.com'
}

export enum HealthFileCategoryEnum {
  INEFrontPhotography = "INE Front Photography",
  INEPhotography = "INE Photography",
  INEBackPhotography = "INE Back Photography",
  FrontPhotography = "Front Photography",
  DoctorAddressPhotography = "Doctor Address Photography",
  ProfessionalCertificatePhotography = "Professional Certificate Photography",
  AddressPhotography = "Address Photography",
  DiplomaCertificatePhotography = "Diploma Certificate Photography",
  NurseHealthContract = "Nurse Health Contract",
  DoctorHealthContract = "Doctor Health Contract",
  AmbulanceHealthContract = "Ambulance Health Contract"
}

export enum SubmissionExamStatusCD {
  Passed = "PASSED",
  Failed = "FAILED",
  Incomplete = "INCOMPLETE"
}

export enum VehiclePhysicalReviewCD {
  Pending = 440,
  Accepted = 441,
  Rejected = 442,
  IDENTITY_DOCUMENT = "IDENTITY_DOCUMENT",
  DRIVING_LICENSE = "DRIVING_LICENSE"
}

export enum AnswerTypeEnum {
  ANSWER_TYPE = 'ANSWER_TYPE'
}

export enum FoodOrderStatusCD {
  Cancelled = "Cancelled",
  Rejected = "Rejected",
  Created = "Created",
  Delivered = "Delivered",
  Ongoing = "OnTheWayToDelivery",
  All = ""
}

export enum AppointmentStatusCD {
  Created = "C",
  Processing = "P",
  Cancelled = "PD",
  Completed = "A",
  Disabled = "D",
  Booked = "B"
}

export enum TaxRegimeCodeEnum {
  TAX_REGIME_INDIVIDUAL = 60,
  TAX_REGIME_LEGAL = 61
}

export enum SectionTypeEnum {
  BillingAddress = "BillingAddress",
  ProfessionalInfo = "ProfessionalInfo",
  OfficeAddress = "OfficeAddress",
  Course = "Course",
  Speciality = "Speciality",
}

export enum TaxDocumentEnum {
  TaxRegime = "TAX_REGIME",
  TaxDoc = "TAX_DOCUMENT",
  Fiel = "ADVANCE_ELECTRONIC_CERTIFICATE",
  FielKeyTitle = "ADVANCE_ELECTRONIC_KEY",
  FielPassword = "ADVANCE_ELECTRONIC_PASSWORD",
  CsdCertificate = "CSD_CERTIFICATE",
  CsdPassword = "CSD_PASSWORD",
  CsdKeyTitle = "CSD_KEY",

  defaultImage = "https://dev-api.vooyapp.com/default_attachments/tax_docs/tick.png"
}

export enum VehicleTypeIDEnum {
  BICYCLE = 1,
  MOTORCYCLE = 2,
  CAR = 3,
  PICKUPANDVAN = 4,
}

export enum GenderCDEnum {
  Male = 3,
  Female = 4,
}

export enum ProfileStatusCD {
  All = "All",
  Registered = "REGISTER",
  ActiveUsers = "ACTIVE"
}

export enum CategoryUIdEnum {
  CarAndVanRegistration = "8EFAC710D8",
  MotorCycleAndCycleRegistration = "ADDF5AE5D8"
}

export enum TransactionTypeEnum {
  All = '',
  AddMoney = 'ADD_MONEY_TRANSACTION',
  WithdrawMoney = 'WITHDRAW_REQUEST_TRANSACTION'
}

export enum ChargesTypeEnum {
  CouponDiscount = "CouponDiscount"
}